import sectionCardFeeSizeImgCss from '../css-snippets/section-card-fee-size-img';

const html = `
<style>${sectionCardFeeSizeImgCss}</style>
<div
  class="wrapper-container"
  id="wrapper-container-vk4hgl"
  data-id="vk4hgl"
  data-attribute="wrapper-container"
  data-background-color="#ffffff"
  style="
    background-color: rgb(255, 255, 255);
    background-image: url('https://cdn.skyfastimg.com/images/2025/12/02/image-692e8be71b5bd2a22046d802.webp?w=1200&amp;h=50&amp;q=80');
    --overlay-color: rgba(0, 0, 0, 0.2);
  "
  data-enable-background-image="true"
  data-background-img="https://cdn.skyfastimg.com/images/2025/12/02/image-692e8be71b5bd2a22046d802.webp?w=1200&amp;h=50&amp;q=80"
  data-background="#ffffff"
  data-overlay-enable="true"
  data-image-enable="true"
  data-top-padding="true"
  data-bottom-padding="true"
>
  <div
    data-attribute="wrapper-content"
    data-center-y="true"
    class="wrapper-content container"
  >
    <div
      class="wrap-image"
      data-attribute="wrap-image"
      data-order="1"
      style="order: 1"
    >
      <img
        loading="lazy"
        data-attribute="image"
        src="https://img.funnelish.com/24176/0/1762353372-AFTER%20%282%29.png"
        alt=""
      />
    </div>
    <div
      data-attribute="card-content"
      data-order="2"
      class="wrap-text-ct"
      style="order: 2"
    >
      <h2 style="text-align: center">
        <span style="color: rgb(67, 104, 224)"
          ><strong>People All Across the USA</strong></span
        >
      </h2>
      <h2 style="text-align: center">
        <strong
          >Are Using VetiFlow™ to Protect Their Dogs From Kidney Disease</strong
        >
      </h2>
      <p style="text-align: center">&nbsp;</p>
      <p>
        <span style="background-color: transparent; color: rgb(0, 0, 0)"
          ><strong
            >Dog owners everywhere are raving about VetiFlow's Triple-Defense
            PRO™ Technology.</strong
          ></span
        >
      </p>
      <p>
        <span style="background-color: transparent; color: rgb(0, 0, 0)"
          >Countless dog parents report life-changing improvements after just
          days, with most never going back to regular bowls.</span
        >
      </p>
      <p>
        <span style="background-color: transparent; color: rgb(0, 0, 0)"
          ><strong
            >Within days of using VetiFlow™, you can expect:</strong
          ></span
        >
      </p>
      <ul>
        <li>No more slimy bowls to scrub</li>
        <li>Your dog drinking noticeably more water</li>
        <li>Crystal clear water that stays fresh for days</li>
      </ul>
      <p>&nbsp;</p>
      <p>
        <span style="background-color: transparent; color: rgb(0, 0, 0)"
          >❌ No more constant worry about kidney disease</span
        >
      </p>
      <p>
        <span style="background-color: transparent; color: rgb(0, 0, 0)"
          >❌ No more guilt about dirty water while you're at work</span
        >
      </p>
      <p>
        <span style="background-color: transparent; color: rgb(0, 0, 0)"
          >You'll feel relief knowing you're protecting your dog from the #2
          killer, and finally have the peace of mind you deserve as a dog
          parent.</span
        >
      </p>
    </div>
  </div>
</div>

`;
export default html;
